import {  s3sClient  } from "./index";


export const newLogin = (payload) => s3sClient.post(`azure_usermanagment/signin`, payload);

export const getUserInfo = (token) => s3sClient.get(`azure_usermanagment/user/info`, { headers: {"Authorization" : `Bearer ${token}`} } );

export const ssoLogOut = (payload) => s3sClient.post(`azure_usermanagment/sso/logout`, payload);





